"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SlateReactPresentation = SlateReactPresentation;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SlatePresentationContext = _react["default"].createContext(null);

function useSlatePresentation() {
  return _react["default"].useContext(SlatePresentationContext);
}

function isText(value) {
  // TODO: maybe use 'is-plain-object' instead of instanceof Object
  return value instanceof Object && typeof value.text === 'string';
}

function isElement(value) {
  // TODO: maybe use 'is-plain-object' instead of instanceof Object
  return value instanceof Object && Array.isArray(value.children);
}

function Element(_ref) {
  var _ref$element = _ref.element,
      element = _ref$element === void 0 ? {
    children: []
  } : _ref$element;

  var _useSlatePresentation = useSlatePresentation(),
      renderElement = _useSlatePresentation.renderElement;

  return _react["default"].createElement(_react["default"].Fragment, null, renderElement({
    attributes: {},
    children: _react["default"].createElement(Children, {
      children: element.children
    }),
    element: element
  }));
}

function Leaf(_ref2) {
  var _ref2$leaf = _ref2.leaf,
      leaf = _ref2$leaf === void 0 ? {
    text: ''
  } : _ref2$leaf;

  var _useSlatePresentation2 = useSlatePresentation(),
      renderLeaf = _useSlatePresentation2.renderLeaf,
      LeafWrapper = _useSlatePresentation2.LeafWrapper;

  return _react["default"].createElement(_react["default"].Fragment, null, renderLeaf({
    attributes: {},
    children: _react["default"].createElement(LeafWrapper, null, leaf.text),
    leaf: leaf,
    text: leaf.text
  }));
}

function Children(_ref3) {
  var _ref3$children = _ref3.children,
      children = _ref3$children === void 0 ? [] : _ref3$children;
  return _react["default"].createElement(_react["default"].Fragment, null, children.map(function (child, i) {
    if (isElement(child)) {
      return _react["default"].createElement(Element, {
        key: i,
        element: child
      });
    } else {
      return _react["default"].createElement(Leaf, {
        key: i,
        leaf: child
      });
    }
  }));
}

function SlateReactPresentation(_ref4) {
  var _ref4$value = _ref4.value,
      value = _ref4$value === void 0 ? [] : _ref4$value,
      _ref4$renderElement = _ref4.renderElement,
      renderElement = _ref4$renderElement === void 0 ? function (props) {
    return _react["default"].createElement(DefaultElement, props);
  } : _ref4$renderElement,
      _ref4$renderLeaf = _ref4.renderLeaf,
      renderLeaf = _ref4$renderLeaf === void 0 ? function (props) {
    return _react["default"].createElement(DefaultLeaf, props);
  } : _ref4$renderLeaf,
      _ref4$LeafWrapper = _ref4.LeafWrapper,
      LeafWrapper = _ref4$LeafWrapper === void 0 ? "span" : _ref4$LeafWrapper;
  return _react["default"].createElement(SlatePresentationContext.Provider, {
    value: {
      renderElement: renderElement,
      renderLeaf: renderLeaf,
      LeafWrapper: LeafWrapper
    }
  }, _react["default"].createElement(Children, {
    children: value
  }));
}

function DefaultElement(_ref5) {
  var children = _ref5.children,
      element = _ref5.element;
  return _react["default"].createElement("div", null, children);
}

function DefaultLeaf(_ref6) {
  var children = _ref6.children,
      leaf = _ref6.leaf;
  return _react["default"].createElement("span", null, children);
}
//# sourceMappingURL=index.js.map